// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"88":"hy","736":"vendor"}[chunkId] + "." + {"88":"4de5d762000274603863","736":"4cef728106ff2694ca46"}[chunkId] + ".css";
};